import { Button, Modal } from '@/components';
import { useSendSms } from '@/hooks';
import type { SiteData } from '@/types/site';
import { useState } from 'react';

interface MotorControlModalProps {
  isOpen: boolean;
  site: SiteData | null;
  onClose: () => void;
}

export default function MotorControlModal({
  isOpen,
  site,
  onClose,
}: Readonly<MotorControlModalProps>) {
  // const { toast } = useToast();
  const [isProcessing, setIsProcessing] = useState(false);
  const { mutate: sendSms } = useSendSms();
  if (!site) return null;

  const motorCount = site.motorActivateCount || 0;

  const handleMotorOn = () => {
    const result = window.confirm('모터를 켜시겠습니까?');

    if (result && site.cdmaNumber && site.cdmaNumber.length > 10) {
      setIsProcessing(true);
      sendSms({
        phone: site.cdmaNumber,
        message: '$$MON01',
        refkey: 'motor_on',
      });
      alert('모터를 켰습니다.');
    }
  };

  const handleMotorOff = () => {
    const result = window.confirm('모터를 끄시겠습니까?');
    if (result && site.cdmaNumber && site.cdmaNumber.length > 10) {
      setIsProcessing(true);
      sendSms({
        phone: site.cdmaNumber,
        message: '$$MOF01',
        refkey: 'motor_off',
      });
      alert('모터를 끄였습니다.');
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="모터 제어"
      size="lg"
      closeOnBackdropClick={!isProcessing}
    >
      <div className="p-6">
        {/* 사이트 정보 */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg">
          <h3 className="font-medium text-gray-900 mb-2">{site.name}</h3>
          <p className="text-sm text-gray-600">{site.address}</p>

          <p className="text-sm text-gray-500 mt-1">
            CDMA 번호: {site.cdmaNumber}
          </p>

          <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-700">
              제어 당 1회의 문자 발송 요금이 청구됩니다.
            </p>
          </div>
        </div>

        {/* 전체 모터 리셋 */}
        <div className="mb-6">
          <h4 className="font-medium text-gray-900 mb-3">모터 제어</h4>
          <div className="flex gap-2">
            <Button variant="danger" onClick={handleMotorOff}>
              {' '}
              모터 끄기{' '}
            </Button>
            <Button variant="primary" onClick={handleMotorOn}>
              모터 켜기
            </Button>
          </div>
        </div>

        {motorCount === 0 && (
          <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-800">
              이 현장에는 설치된 모터가 없습니다.
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
}
